{
  "mainMenu": "Main menu",
  "planned": "This page is coming soon.",
  "groups": {
    "messaging": "Messaging",
    "gateway": "Gateway",
    "billing": "Billing",
    "administration": "Administration",
    "money": "Money",
    "operations": "Operations"
  },
  "entries": {
    "overview": "Overview",
    "send": "Send",
    "bulkSend": "Bulk send",
    "messages": "Messages",
    "devices": "Devices",
    "apiKeys": "API keys",
    "webhooks": "Webhooks",
    "apiGuide": "API guide",
    "wallet": "Wallet",
    "topUp": "Top up",
    "plans": "Plans",
    "invoices": "Invoices",
    "refunds": "Refunds",
    "adminOverview": "Admin overview",
    "users": "Users",
    "roles": "Roles",
    "allDevices": "All devices",
    "allMessages": "All messages",
    "webhookDeliveries": "Webhook deliveries",
    "planEditor": "Plan limits",
    "payments": "Payments",
    "reviewQueue": "Review queue",
    "transfers": "Transfers",
    "adminRefunds": "Refunds",
    "reconciliation": "Reconciliation",
    "prices": "Prices",
    "reports": "Reports",
    "jobs": "Jobs",
    "status": "System status",
    "audit": "Audit log",
    "settings": "Settings",
    "pages": "Pages"
  },
  "titles": {
    "batch": "Batch",
    "device": "Device",
    "webhook": "Webhook",
    "topup": "Top-up",
    "user": "User",
    "role": "Role",
    "payment": "Payment",
    "transfer": "Transfer",
    "refund": "Refund",
    "job": "Job",
    "setting": "Setting",
    "page": "Page"
  },
  "account": {
    "menu": "Account",
    "profile": "Profile",
    "security": "Security",
    "sessions": "Sessions",
    "notifications": "Email preferences",
    "support": "Support",
    "delete": "Delete account",
    "signOut": "Sign out"
  },
  "palette": {
    "title": "Search",
    "trigger": "Search…",
    "placeholder": "Search pages, devices, messages…",
    "goTo": "Go to",
    "recent": "Recent",
    "devices": "Devices",
    "messages": "Messages",
    "users": "Users",
    "noResults": "No results",
    "searching": "Searching…"
  },
  "alerts": {
    "label_one": "Alerts, {{count}} item",
    "label_other": "Alerts, {{count}} items",
    "none": "Nothing needs attention",
    "failedMessages": "Failed messages (24 h)",
    "offlineDevices": "Offline devices",
    "transfersToReview": "Transfers awaiting review",
    "openRefunds": "Open refunds",
    "paymentsToReview": "Payments needing review",
    "failedJobs": "Failed jobs"
  },
  "shortcuts": {
    "title": "Keyboard shortcuts",
    "openPalette": "Open search",
    "openReference": "Show this list",
    "goTo": {
      "overview": "Go to overview",
      "messages": "Go to messages",
      "send": "Go to send",
      "devices": "Go to devices",
      "wallet": "Go to wallet",
      "transfers": "Go to transfers",
      "users": "Go to users"
    },
    "then": "then"
  }
}
